"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { Link } from "react-router-dom"
import "../styles/home.css"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import whatsapp from "../assets/whatsapp-icon.png"
import { FaCalendarAlt, FaChevronLeft, FaChevronRight } from "react-icons/fa"

// Custom arrows for slider
const PrevArrow = (props) => {
  const { onClick } = props
  return (
    <button className="custom-arrowlt prev-arrowlt" onClick={onClick}>
      <FaChevronLeft />
    </button>
  )
}

const NextArrow = (props) => {
  const { onClick } = props
  return (
    <button className="custom-arrowlt next-arrowlt" onClick={onClick}>
      <FaChevronRight />
    </button>
  )
}

function Home() {
  const [eventos, setEventos] = useState([])
  const [temposRestantes, setTemposRestantes] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    carregarEventos()
  }, [])

  const carregarEventos = async () => {
    try {
      setLoading(true)
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/events`)
      setEventos(response.data)

      const tempos = {}
      response.data.forEach((evento) => {
        tempos[evento._id] = calcularTempoRestante(evento)
      })
      setTemposRestantes(tempos)
      setLoading(false)
    } catch (err) {
      console.error("Erro ao buscar eventos", err)
      setLoading(false)
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const novosTempos = {}
      eventos.forEach((evento) => {
        novosTempos[evento._id] = calcularTempoRestante(evento)
      })
      setTemposRestantes(novosTempos)
    }, 1000)

    return () => clearInterval(interval)
  }, [eventos])

  const calcularTempoRestante = (evento) => {
    let targetDate
    if (evento.status === "em breve") {
      targetDate = new Date(evento.dataInicio).getTime()
    } else if (evento.status === "aberto") {
      targetDate = new Date(evento.dataFim).getTime()
    } else {
      return { dias: 0, horas: 0, minutos: 0, segundos: 0, zerado: true }
    }

    const agora = new Date().getTime()
    const diferenca = targetDate - agora

    if (diferenca <= 0) {
      return { dias: 0, horas: 0, minutos: 0, segundos: 0, zerado: true }
    }

    const dias = Math.floor(diferenca / (1000 * 60 * 60 * 24))
    const horas = Math.floor((diferenca % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutos = Math.floor((diferenca % (1000 * 60 * 60)) / (1000 * 60))
    const segundos = Math.floor((diferenca % (1000 * 60)) / 1000)

    return { dias, horas, minutos, segundos, zerado: false }
  }

  const formatarData = (dataString) => {
    const data = new Date(dataString)
    return data.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  }

  return (
    <div className="home-wrapperlt">
      {/* 🔹 Seção de Eventos */}
      <section className="eventos-sectionlt">
        <div className="section-headerlt">
          <h2>Próximos Eventos</h2>
          <p>Confira os eventos disponíveis e garanta sua participação</p>
        </div>

        <div className="eventos-containerhomelt">
          {loading ? (
            <div className="loading-containerlt">
              <div className="loading-spinnerlt"></div>
              <p>Carregando eventos...</p>
            </div>
          ) : eventos.filter((evento) => evento.status === "aberto" || evento.status === "em breve").length > 0 ? (

            <Slider {...settings} className="eventos-sliderlt">
              {eventos
                .filter((evento) => evento.status === "aberto" || evento.status === "em breve")
                .map((evento) => (
                  <div key={evento._id} className="evento-card-wrapperlt">
                    <div className="evento-cardhomelt">
                      <div className="evento-image-containerlt">
                        <img
                          src={`https://api.ticketdovaqueiro.com/uploads/${evento.imagem}`}
                          alt={evento.nome}
                          className="cartaz-eventolt"
                        />
                        <div className="evento-statuslt">{evento.status}</div>
                      </div>

                      <div className="evento-infohomelt">
                        <div className="evento-infonomelt">
                          <h2>{evento.nome}</h2>
                        </div>

                        {temposRestantes[evento._id] && (
                          <div className="evento-detailslt">
                            <div className="evento-dateslt">
                              <div className="date-itemlt">
                                <FaCalendarAlt className="date-iconlt" />
                                <div>
                                  <span>De:</span> {formatarData(evento.dataInicio)}
                                </div>
                              </div>
                              <div className="date-itemlt">
                                <FaCalendarAlt className="date-iconlt" />
                                <div>
                                  <span>Até:</span> {formatarData(evento.dataFim)}
                                </div>
                              </div>
                            </div>

                            <div className="contador-cronometrolt">
                              <h5>{evento.status === "em breve" ? "Início das vendas em:" : "Encerramento em:"}</h5>
                              <div className="contador-fundolt">
                                <div className="contador-itemlt">
                                  <span className="contador-principallt">
                                    {String(temposRestantes[evento._id].dias).padStart(2, "0")}
                                  </span>
                                  <span className="contador-descricaolt">dias</span>
                                </div>
                                <div className="contador-itemlt">
                                  <span className="contador-principallt">
                                    {String(temposRestantes[evento._id].horas).padStart(2, "0")}
                                  </span>
                                  <span className="contador-descricaolt">horas</span>
                                </div>
                                <div className="contador-itemlt">
                                  <span className="contador-principallt">
                                    {String(temposRestantes[evento._id].minutos).padStart(2, "0")}
                                  </span>
                                  <span className="contador-descricaolt">min</span>
                                </div>
                                <div className="contador-itemlt">
                                  <span className="contador-principallt">
                                    {String(temposRestantes[evento._id].segundos).padStart(2, "0")}
                                  </span>
                                  <span className="contador-descricaolt">seg</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        <Link to={`/evento/${evento._id}`} className="botao-comprlt">
                          COMPRAR
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
            </Slider>
          ) : (
            <div className="no-eventslt">
              <p>Não há eventos disponíveis no momento.</p>
            </div>
          )}
        </div>
      </section>

      {/* 🔹 Seção Call to Action */}
      <section className="info-sectionlt">
        <div className="section-headerlt lightlt">
          <h2>Garanta sua participação</h2>
          <p>Compre suas senhas antecipadas e evite filas</p>
        </div>

        <div className="info-containerhomelt">
          <div className="cta-gridlt">
            {/* Card de Benefícios */}
            <div className="cta-cardlt">
              <div className="cta-card-contentlt">
                <h3>Vantagens de comprar antecipado</h3>
                <ul className="benefits-listlt">
                  <li>
                    <span className="benefit-iconlt">✓</span>
                    <span>Garantia de participação no evento</span>
                  </li>
                  <li>
                    <span className="benefit-iconlt">✓</span>
                    <span>Evite filas e aglomerações</span>
                  </li>
                  <li>
                    <span className="benefit-iconlt">✓</span>
                    <span>Planejamento antecipado</span>
                  </li>
                  <li>
                    <span className="benefit-iconlt">✓</span>
                    <span>Processo 100% digital e seguro</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Card de Estatísticas */}
            <div className="cta-cardlt stats-cardlt">
              <div className="cta-card-contentlt">
                <h3>Nossa plataforma em números</h3>
                <div className="stats-gridlt">
                  <div className="stat-itemlt">
                    <span className="stat-numberlt">20+</span>
                    <span className="stat-labellt">Eventos realizados</span>
                  </div>
                  <div className="stat-itemlt">
                    <span className="stat-numberlt">1k+</span>
                    <span className="stat-labellt">Senhas vendidas</span>
                  </div>
                  <div className="stat-itemlt">
                    <span className="stat-numberlt">100%</span>
                    <span className="stat-labellt">Clientes satisfeitos</span>
                  </div>
                  <div className="stat-itemlt">
                    <span className="stat-numberlt">100%</span>
                    <span className="stat-labellt">Segurança</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Coluna de Contato WhatsApp */}
            <div className="whatsapp-contactlt">
              <h2>Quer fazer um orçamento?</h2>
              <p>Estamos prontos para atender sua vaquejada com as melhores soluções!</p>
              <a href="https://wa.me/5583991740119" className="whatsapp-buttonlt">
                <img src={whatsapp || "/placeholder.svg"} alt="WhatsApp" />
                <span>Fale Conosco</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home
